import Vue from 'vue'
import VueRouter from 'vue-router'
import {sysVariable} from "@/utils/sys-variable";
import {getThemeParams} from "@/utils/theme"
import store from '../store'
import {baseURL} from "@/utils/url";
import {getPlatformInstance} from "@/platforms"
let serviceHallCategoryModel = getThemeParams('hall_default_category');
Vue.use(VueRouter);

const Index = () => import('@/views/home/Index');
const Home = () => import('@/views/home/Home');
const HomeSearchPage = () => import('@/views/home/SearchPage');
const HomeSearchResult = () => import('@/views/home/SearchResult');
const Message = () => import('@/views/message/Message');
const ServiceHallByDept = () => import('@/views/service-hall/ServiceHallByDept');
const ServiceHallByMatter = () => import('@/views/service-hall/ServiceHallByMatter');
// 办事大厅
const ServiceHall = serviceHallCategoryModel == '0'?ServiceHallByDept:ServiceHallByMatter;
// 服务筛选
const ServiceFilter = () => import('@/views/service-hall/ServiceFilter');
//服务详情页
const ServiceDetail = () => import('@/views/service-hall/ServiceDetail');
// 效能监督
const Efficacy = () => import('@/views/efficacy/Efficacy');
// 专题更多
const ProjectMore = () => import('@/views/project/projectMore');
// 专题详情
const ProjectDetails = () => import('@/views/project/projectDetails');
// 个人通知
const Notice = () => import('@/views/notice/notice');
// 个人通知详情
const NoticeDetails = () => import('@/views/notice/noticeDetails');
//三张清单
const ThreeList = () => import('@/views/three-list/ThreeList');
const MatterList = () => import('@/views/three-list/MatterList');
const MatterFilter = () => import('@/views/three-list/MatterFilter');
const DutiesList = () => import('@/views/three-list/DutiesList');
const MatterDetail = () => import('@/views/three-list/MatterDetail');

// 设置
const Setting = () => import('@/views/setting/setting');
const UserInfo = () => import('@/views/setting/UserInfo');
const Mine = () => import('@/views/mine/Mine');
const MineCollect = () => import('@/views/mine/MineCollect');
const HomeTab = () => import('@/views/HomeTab');
//我的事项
const MyItems = () => import('@/views/my-items/MyItems');
const MyTransfer = () =>import('@/views/my-transfer/MyTransfer');
const IssuedTask = () => import('@/views/issued-task/IssuedTask');
const FlowList = () => import('@/views/flow/FlowList');
const FlowListSearch = () => import('@/views/flow/FlowListSearch')
// 服务资讯更多页
const ServiceNews = () => import('@/views/home/ServiceNews/Index');
// 服务资讯详情页
const ServiceNewsDetails = () => import('@/views/home/ServiceNews/Details');
//通讯录
const AddressBook = () => import('@/views/address-book/AddressBook');
const UserDetail = () => import('@/views/address-book/UserDetail');
const EditPersonalInfo = () => import('@/views/address-book/EditPersonalInfo');
//登录
const Login = () => import('@/views/login/Login');
//Empty 空空如也
const Error = () => import('@/views/error/Error');

const routes = [
    {
        path: '/',
        redirect: '/home',
        meta: {
            showTabBar: true
        },
    },
    {
        path: '/home',
        component: Index,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name:"MOBILE_PORTAL",
                component: Home,
                meta: {
                    title:'首页',
                    showTabBar: true
                },
            },
            {
                path: '/search',
                component: HomeSearchPage,
                meta: {
                    title: '查询',
                    showTabBar: false
                },
            },
            {
                path: '/searchResult',
                component: HomeSearchResult,
                meta: {
                    title: '查询',
                    showTabBar: false
                },
            },
            {
                path: '/serviceNews',
                component: ServiceNews,
                meta: {
                    title: '服务资讯',
                    showTabBar: false
                },
            },
            {
                path: '/serviceNews/detail/:newId',
                component: ServiceNewsDetails,
                props: true,
                meta: {
                    title: '服务资讯详情页',
                    showTabBar: false
                },
            },
        ]
    },
    {
        path: '/mine',
        name:'MINE',
        component: Mine,
        meta: {
            showTabBar: true,
            title: '我的'
        }
    },
    {
        path: '/mine/collect',
        name:'MINE_COLLECT',
        component: MineCollect,
        meta: {
            showTabBar: false,
            title: '我的收藏'
        }
    },
    {
        path: '/login',
        name:"LOGIN",
        component: Login,
        props:true,
        meta: {
            title: '登录',
            keepAlive: true,
            showTabBar: false
        },
        children: [
            { path: ':redirect', name: 'login', component: Login }
        ]
    },
    {
        path: '/efficacy',
        name:"EFFICACY",
        component: Efficacy,
        meta: {
            showTabBar: true,
            title:"效能监督"
        }
    },
    {
        path: '/project',
        name:"PROJECT",
        component: ProjectMore,
        meta: {
            showTabBar:false,
            title:"专题服务"
        }
    },
    {
        path: '/project/details/:id',
        component: ProjectDetails,
        props:true,
        meta: {
            showTabBar:true,
        }
    },
    {
        path: '/notice',
        name:"NOTICE",
        component: Notice,
        meta: {
            showTabBar:false,
            title: "个人通知"
        }
    },
    {
        path: '/notice/noticeDetails',
        component: NoticeDetails,
        meta: {
            showTabBar:false,
            title: "个人通知详情"
        }
    },
    {
        path: '/setting',
        name:"SETTING",
        component: Setting,
        meta: {
            showTabBar: false,
            title: "设置"
        }
    },
    {
        path: '/userInfo',
        name:"USER_INFO",
        component: UserInfo,
        meta: {
            showTabBar: false,
            title: "个人资料"
        }
    },
    {
        path: '/homeTab/serviceHall',
        component: () => import('@/views/service-hall/ServiceHall'),
        name:"SERVICE_HALL",
        meta: {
            showTabBar: true,
            title:"服务大厅"
        },
        props:(route) => ({
            renderComponent: new Promise((resolve, reject) => {
                try {
                    if(getThemeParams('hall_default_category') == '0'){
                        resolve(import('@/views/service-hall/ServiceHallByDept'))
                    }else{
                        resolve(import('@/views/service-hall/ServiceHallByMatter'))
                    }
                }catch (e) {
                    reject(e)
                }
            }),
        })
    },
    {
        path: '/serviceHall/detail/:id',
        component: ServiceDetail,
        name:"SERVICE_DETAIL",
        meta: {
            showTabBar: false,
            title:"服务详情页",
            navShow: 'serviceNav'
        },
        props: true
    },
    {
        path: '/homeTab/serviceHall/filter',
        component: ServiceFilter,
        meta: {
            showTabBar: false,
            title:"服务筛选"
        }

    },
    {
        path: '/homeTab',
        component: HomeTab,
        meta: {
            showTabBar: true
        },
        children: [
            {path: 'myItems/:type', name: 'MY_ITEMS', component: MyItems, props: true, meta: {title: '我的事项',showTabBar: false}},
            {path: 'myTransfer', name: 'MY_TRANSFER', component: MyTransfer, props: true, meta: {title: '我的事项',showTabBar: false}},
            {path: 'issuedTask', name: 'ISSUED_TASK', component: IssuedTask, meta: {title: '填报任务',showTabBar: false}},
        ]
    },
    {path: '/flow/list/:type/:flowKey/:searchJson?', name: 'FLOW_LIST', component: FlowList, props: true},
    {
        path: '/flow/listSearch/:flowId/:type/:flowKey/:innerSearchJson/:searchFieldJson',
        name: 'FLOW_LIST_SEARCH',
        component: FlowListSearch,
        props: true,
        meta: {title: '搜索'}
    },
    {
        path:'/threeList',
        name:"THREE_LIST",
        component:ThreeList,
        meta:{
            showTabBar: true,
            title:"三张清单"
        },
    },
    {
        path: '/threeList/matter/filter',
        name: 'MATTER_FILTER',
        component: MatterFilter,
        meta: {title: '筛选',showTabBar: false}
    },
    {
        path: '/threeList/duties',
        name: 'DUTIES_LIST',
        component: DutiesList,
        meta: {title: '职责清单',showTabBar: false}
    },
    {
        path: '/threeList/matter',
        name: 'MATTER_LIST',
        component: MatterList,
        meta: {title: '事项清单',showTabBar: false}
    },
    {
        path: '/threeList/matter/detail',
        name: 'MATTER_LIST',
        component: MatterDetail,
        meta: {showTabBar: false}
    },
    {
        path: '/messageList/:uid?/:uuid?',
        name:'MASSAGE_LIST',
        component: Message,
        props: true,
        meta: {
            showTabBar: false,
            title:"动态"
        }
    },
    {path: '/addressBook', name: 'ADDRESS_BOOK',component: AddressBook, meta: {title: '通讯录', keepAlive: true}},
    {path: '/addressBook/userDetail/:uuid?', name: 'USER_DETAIL', component: UserDetail, props: true,},
    {path: '/addressBook/me', name: 'ME', redirect: '/addressBook/userDetail/'},
    {path: '/addressBook/editPersonalInfo', name: 'EDIT_PERSONAL_INFO', component: EditPersonalInfo, meta: {title: '编辑个人信息'}},
    { //校验所有路由后找不到路径跳转404页面 只能放在路由集合的最后
        path: '*',
        name: 'NotFound',
        redirect: '/empty/notfound/页面走丢了'
    },
    {path: '/empty/:type/:desc?', name: 'Empty', component: Error,props: true}
];

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if(to.fullPath != '/homeTab/serviceHall/filter') {
        if (to.fullPath == '/homeTab/serviceHall') {
            if (from.fullPath != '/homeTab/serviceHall/filter' && from.fullPath != '/homeTab/serviceHall') {
                let params = {
                    keyword: undefined,
                    target: undefined,//服务对象
                    publisher: undefined,//所属部门
                    handleWay: undefined,//办理途径
                    type: undefined,//事项类型
                    related: undefined,
                };
                store.commit("updateServiceParams", params);
            }
        }
    }
    if (to.meta.title) {
        document.title = to.meta.title
    }
    // 设置页面是否显示导航条
    if (to.meta.showTabBar) {
        store.commit('toggleTabbarShow', to.meta.showTabBar);
    } else {
        store.commit('toggleTabbarShow', false);
    }
    // 设置页面标题
    let title = to.matched.reduce((a, c) => a + (c.meta.title || ''), '')
    sysVariable('MOBILE_PAGE_TITLE')
        .then(resp => {
            const config = JSON.parse(resp)
            const configTitle = to.matched.reduce((a, c) => a + (config[c.name] || ''), '')
            if (configTitle) title = configTitle
            if (title) getPlatformInstance().then(platform => platform.setTitle(title))
        })
        .catch(error => {
            if (title) getPlatformInstance().then(platform => platform.setTitle(title))
        })
    // 重置页面滑动
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // 前端路由跳转时执行urlChange
    getPlatformInstance().then(platform => platform.urlChange(to))

    next()
});

export default router
